import request from '@/utils/request';
import request2 from '@/utils/request2';

//视频模板分类和列表
export function videoGetList(params) {
    return request({
        method: 'get',
        url: 'video/getList',
		params
    })
}
export function videoGetListV2(params) {
    return request({
        method: 'get',
        url: 'video/getListV2',
		params
    })
}

//(取消)收藏视频模板
export function videoCollect(params) {
    return request({
        method: 'get',
        url: 'video/collect',
		params
    })
}

//获取模板详情
export function videoDetail(params) {
    return request({
        method: 'get',
        url: 'video/detail',
		params
    })
}

//上传视频
export function uploadUploadVideo(data) {
    return request({
        method: 'post',
        url: 'upload/uploadVideo',
		data:data
    })
}
export function uploadUploadVideoV2(data) {
    return request2({
        method: 'post',
        url: 'resource/upload2',
		data:data
    })
}
export function uploadUploadImage(data) {
    return request({
        method: 'post',
        url: 'upload/uploadImage',
		data:data
    })
}
//上传音频
export function uploadUploadVoice(data) {
    return request({
        method: 'post',
        url: 'upload/uploadVoice',
		data:data
    })
}

//语音模型分类和列表
export function voiceGetModelList(params) {
    return request({
        method: 'get',
        url: 'voice/getModelList',
		params
    })
}


//音频生成
export function voiceGenerate(data) {
    return request({
        method: 'post',
        url: 'voice/generate',
		data:data
    })
}

// 视频生成
export function videoCreate(data) {
    return request({
        method: 'post',
        url: 'video/create',
		data:data
    })
}


//视频状态
export function videoQuery(params) {
    return request({
        method: 'get',
        url: 'video/query',
		params
    })
}